import React from 'react';

import { useRemoveDeliveryModalMutation } from 'generated/graphql';


export function useRemoveDeliveryModal() {
  const [
    fnMutate,
    tuple
  ] = useRemoveDeliveryModalMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
